import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  RoomMaList,
  CityFilterAction,
  buildingFilterAction,
  TowerFilterAction,
  FloorFilterAction,
} from '../../Redux/action/roomTraingAction';
import { dataUser } from '../Helpers/util';
import axiosInstance from '../../utils/axiosInstance';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { param } from 'jquery';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwInput from '../Common/FormComponent/SwInput';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwCheckbox from '../Common/FormComponent/SwCheckbox';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import AntDTimePicker from '../Common/AntDDateTimePicker/AntDTimePicker';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwSwitchButtons from '../Common/SwSwitchButtons/SwSwitchButtons';
import SwIconButton from '../Common/SwIconButton/SwIconButton';
import SwButton from '../Common/SwButtons/SwButtons';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

var cityOption = [];
var buildingOption = [];
var towerOption = [];
var FloorOption = [];

class RoomFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshCity: null,
      cityId: '', // Holds the selected City ID
      buildingId: '', // Holds the selected Building ID
      floorId: '', // Holds the selected Floor ID
      cityOptions: [], // List of City options for the dropdown
      buildingOptions: [], // List of Building options for the dropdown
      floorOptions: [],
      refreshBuilding: null,

      // For the floor dropdown
      selectedBuilding: null, // Selected building object
      selectedFloor: null,
      selectedBuildingId: null, // Selected building object
      selectedFloorId: null,
      refreshTower: null,
      refreshFloor: null,
      building_id: '',
      hidVal: null,
      locationSpoc:[],
      buildingCheck: false,
      company_id: UserObj.company_id,
      trainingRoomList: [],
      cityApiData: [],
      buildingApiData: [],
      TowerApiData: [],
      FloorApiData: [],
      setFlagCity: false,
      floor_id: '',
      tower_id: '',
      rtype: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
      name: '',
      floor: '',
      center: '',
      city: '',
      tower: '',
      status: '',
      amen: '',
      capacity: '',
      slot: '',
      price: '',
      booking24: false,
      starttime: '',
      endtime: '',
    };
  }

  setColor = e => {
    this.setState({
      setcolor: true,
    });
  };
  reload = e => {
    const params = {
      company_id: this.state.company_id,
      pgno: this.props.pg,
      num_row: this.props.srow,
      city: '',
    };
    this.props.onSelectLanguage(params);
    this.props.RoomMaList(params);
    window.location.reload();
    this.setState({
      refreshCity: null,
      refreshBuilding: null,
      refreshTower: null,
      rname: '',
      rtype: '',
      capacity: '',
      city: '',
      refreshFloor: null,
      slot: '',
      price: '',
      starttime: '',
      endtime: '',
      status: '',
    });
  };

  setStatus = () => {
    if ((this.state.buildingApiData = [])) {
      this.setState({
        buildingCheck: true,
      });
    }
  };

  togglecheked = e => {
    const isChecked = e.target.checked;
    this.setState({
      [e.target.name]: isChecked,
      hidVal: isChecked, // Set hidVal to true if checked, false otherwise
    });
  };

  locationData1 = async () => {
    try {
      let authToken = JSON.parse(localStorage.getItem("headData"));
  
      const axiosConfig = {
        params: {
          spoc: UserObj.rec_id,
          client: this.state.company_id,
        },
     
      };
  
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/basic-data/get-location-by-spoc`,
        axiosConfig
      );
  
  
      if (response.data.status === "success" && response.data.data.length > 0) {
        this.setState({ locationSpoc: response.data.data }, () => {
        });
      } else {
        this.setState({ locationSpoc: [] }, () => {
     
        });
      }
    } catch (error) {
      console.error("Error fetching locationSpoc:", error);
    }
  };
  openFilter = () => {
  this.setState({ showFilter: true });
};

closeFilter = () => {
  this.setState({ showFilter: false });
};

  // ✅ Fix 5: Remove `await` in `componentDidMount`
 
  

  submitFilter = async(e) => {
    e.preventDefault();
    const { startDate, endDate, selectedBuildingId, locationSpoc, rtype } = this.state;
  
    // Convert dates to UTC format
    const startDateTime = startDate
      ? moment.tz(startDate, "YYYY-MM-DD", "Asia/Kolkata")
          .startOf("day")
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      : null;
  
    const endDateTime = endDate
      ? moment.tz(endDate, "YYYY-MM-DD", "Asia/Kolkata")
          .endOf("day")
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      : null;
  
    // ✅ If selectedBuildingId exists, use it; otherwise, use locationSpoc
    let propertyId = selectedBuildingId
      ? [selectedBuildingId]
      : locationSpoc?.length > 0
      ? locationSpoc.map((item) => item.newId)
      : [];
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let baseParam = {
      pageOffset: this.props.pg,
      pageSize: this.props.pgRowNumber,
      includes: "KPI",
      propertyId, // Correctly assigned propertyId
      type: rtype,
      reqFrom: "cspoc",
      clientId:[newCompanyId.organizationId],
    };
  
    // ✅ Apply additional filters only if they are present
    const filterableFields = {
      name: this.state.name,
      floorId: this.state.selectedFloorId,
      isActive: this.state.status,
      capacity: this.state.capacity,
      timeSlot: this.state.slot,
      pricePerSlot: this.state.price,
      isAvailableAllTime: this.state.meeting_alltime,
      openTime: this.state.meeting_opentime,
      closeTime: this.state.meeting_closetime,
      added_by: this.state.added_by,
      startDate: startDateTime,
      endDate: endDateTime,
    };
  
    Object.entries(filterableFields).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        baseParam[key] = value;
      }
    });
  
    // ✅ API calls with filtered parameters
          try {
    const response = await this.props.RoomMaList(baseParam);
    if (response?.success) {
      this.closeFilter();  // ✅ Close only on success
    }
  } catch (error) {
    console.log("Filter failed");
  }
    this.props.onSelectLanguage(baseParam);
  };

  handleChange = capacity => {
    this.setState({ capacity: capacity.value });
  };

  handelChangeVal = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentWillReceiveProps(props) {
    this.setState({
      trainingRoomList:
        props.roomTraingReducer && props.roomTraingReducer.RoomTrainingData,
    });
    if (props.CityNameReducer && props.CityNameReducer.length != 0) {
      this.setState({
        cityApiData: props.CityNameReducer,
      });
    }
    if (props.BuildingReducer && props.BuildingReducer.length != 0) {
      this.setState({
        buildingApiData: props.BuildingReducer,
        setFlagCity: true,
      });
    }
    if (props.TowerReducer && props.TowerReducer.length != 0) {
      this.setState({
        TowerApiData: props.TowerReducer,
        setFlagCity: true,
      });
    }
    if (props.FloorReducer && props.FloorReducer.length != 0) {
      this.setState({
        FloorApiData: props.FloorReducer,
        setFlagCity: true,
      });
    }
  }

  // Fetch building data from the API
  fetchBuildingData = async () => {
    let organizationId = JSON.parse(localStorage.getItem('headData'));

    try {
      const requestData = {
        ids: [organizationId.organizationId], // List of organization IDs you want to query
        includes: ['properties'], // Any other related properties (e.g., cities)
      };

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}core/organizations/all`,
        requestData,
      );

      // Extract building options
      const buildingOptions = response?.data?.data[0]?.properties?.map(
        property => ({
          value: property.id,
          label: property.name, // Building name
          properties: property, // Attach the property object to later fetch floors
        }),
      );

      // Set the building options in the state
      this.setState({ buildingOptions }); 
    } catch (error) {
      console.error('Error fetching buildings:', error);
    }
  };

  // Handle building change (populate floor options based on the selected building)
  handleBuildingChange = selectedBuilding => {
    const { buildingOptions } = this.state;

    // Find the selected building from the building options
    const building = buildingOptions.find(
      building => building.value === selectedBuilding.value,
    );

    if (building) {
      // Extract the floors for the selected building
      const floorOptions =
        building.properties?.floors?.map(floor => ({
          value: floor.id,
          label: floor.name, // Floor name
        })) || [];

      // Set the selected building and floor options
      this.setState({
        selectedBuilding: selectedBuilding,
        selectedBuildingId: selectedBuilding.value, // Store the full building object
        floorOptions, // Set floor options
        selectedFloor: null, // Reset the selected floor
      });
    }
  };

  // Handle floor change
  handleFloorChange = selectedFloor => {
    this.setState({
      selectedFloor, // Store the selected option object
      selectedFloorId: selectedFloor ? selectedFloor.value : null, // Save only the value (ID)
    });
  };

  componentDidMount() {
    // this.SetCityValue();
    this.locationData1();
    this.fetchBuildingData();
  }

  /*1---setCity---*/
  SetCityValue = city => {
    let params = {
      company_id: this.state.company_id,
    };
    this.props.CityFilterAction(params);
  };
  /*1---setCity---*/
  /*2---getCityDAta---*/
  CityNameMethod = city => {
    this.setState({ city: city.value, refreshCity: city });
    let params = {
      company_id: this.state.company_id,
      cityid: city.value,
    };
    this.props.buildingFilterAction(params);
  };
  /*2---getCityDAta---*/
  /*3---Building---*/
  buildingNameMethod = building => {
    this.setState({ building_id: building.value, refreshBuilding: building });

    let params = {
      company_id: this.state.company_id,
      buildingid: building.value,
    };
    this.props.TowerFilterAction(params);
    this.props.FloorFilterAction(params);
  };
  /*3---Building---*/
  TowerNameMethod = building => {
    this.setState({ tower_id: building.label, refreshTower: building });
    let pars = {
      buildingid: this.state.building_id,
      tower_id: building.value,
      company_id: this.state.company_id,
    };
    this.props.FloorFilterAction(pars);
  };

  FloorNameMethod = building => {
    this.setState({ floor_id: building.label, refreshFloor: building });
  };

  RoomTypemethod = room => {

    const selectedRoomTypes = Array.isArray(room)
      ? room.map(item => item.label)
      : [room.label];

    this.setState({ rtype: selectedRoomTypes });
  };

  render() {
    //--City--///
    const {
      buildingOptions,
      floorOptions,
      selectedBuilding,
      selectedFloor,
    } = this.state;
    const roomType = [
      {
        value: 1,
        label: 'Meeting Room',
      },
      {
        value: 2,
        label: 'Conference Room',
      },
      {
        value: 3,
        label: 'Training Room',
      },
      {
        value: 4,
        label: 'Lounge Room',
      },
    ];
    if (this.state.cityApiData !== 0) {
      cityOption = [];
      this.state.cityApiData &&
        this.state.cityApiData.map((items, i) => {
          cityOption.push({ value: items.city_id, label: items.city_name });
        });
    }
    //--City---///
    //--Building---///

    if (this.state.buildingApiData !== 0) {
      buildingOption = [];
      this.state.buildingApiData &&
        this.state.buildingApiData.map((items, i) => {
          buildingOption.push({
            value: items.building_id,
            label: items.building_name,
          });
        });
    }
    //--Building--///
    //--Tower---///

    if (this.state.TowerApiData !== 0) {
      towerOption = [];
      this.state.TowerApiData &&
        this.state.TowerApiData.map((items, i) => {
          towerOption.push({
            value: items.tower_id,
            label: items.tower_name,
          });
        });
    }
    //--Tower---///
    //--Floor--///

    if (this.state.FloorApiData !== 0) {
      FloorOption = [];
      this.state.FloorApiData &&
        this.state.FloorApiData.map((items, i) => {
          FloorOption.push({
            value: items.floor_id,
            label: items.floor_name,
          });
        });
    }
    //--Floor---///


    return (
      <>
            <SwOffCanvas
       show={this.state.showFilter}
  onClose={this.closeFilter}
  title="Filter"
  footer={
    <>
                        <div className="OffCanvasFooter_Btns">
                        <SwButton
                        
                        variant='dark-outline'
                          type="button"
                          onClick={this.reload}
                        >
                           Reload
                        </SwButton>
                        <SwButton
                        
                          onClick={this.submitFilter}
                        >
                          Apply
                        </SwButton>
                      </div>
    </>
  }
       >
         <form>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Room Name</label>
                          <SwInput
                          type="text"
                          name="name"
                          maxLength="20"
                          value={this.state.name}
                          onChange={this.handelChangeVal}
                          placeholder='Enter Room name'
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className="SwFormLabel">Building Name</label>
                          <SwSelect
                          onChange={this.handleBuildingChange}
                          options={buildingOptions}
                          value={selectedBuilding || null}
                          placeholder='Select Building name'
                          isClearable={false}
                          />
                          <p
                            className={
                              this.state.buildingCheck != false
                                ? 'setb Disp'
                                : 'setb'
                            }
                          >
                            Please Select City Name
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Floor Name</label>
                          <SwSelect
                          onChange={this.handleFloorChange}
                          options={floorOptions}
                          value={
                            selectedFloor
                              ? floorOptions.find(
                                  floor => floor.value === selectedFloor,
                                )
                              : null
                          }
                          placeholder='Select Floor name'
                          isClearable={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Room Type</label>
                          <SwSelect
                          name="rtype"
                          onChange={this.RoomTypemethod}
                          options={roomType}
                          placeholder='Select Room type'
                          isClearable={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Status</label>
                          <div onChange={this.handelChangeVal}>
                              <SwRadio
                              id="status-active"
                              name="status"
                              value='true'
                              label="Active"
                              checked={this.state.status === "true"}
                              onChange={this.handelChangeVal}
                              />
                               <SwRadio
                                id="status-inactive"
                                name="status"
                                value="false"
                                label="Inactive"
                                checked={this.state.status === "false"}
                                onChange={this.handelChangeVal}
                              />
                          </div>
                        </div>
                      </div>
                    </div>
                 
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Seating Capacity</label>
                          <SwInput
                          type="number"
                          name="capacity"
                          maxLength="8"
                          value={this.state.capacity}
                          onChange={this.handelChangeVal}
                          placeholder='Enter Seating Capacity'
                          />
                        </div>
                      </div>
                    </div>
                
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Booking Slot (in Minutes)</label>
                          <SwInput
                          type="number"
                          name="slot"
                          maxLength="8"
                          value={this.state.slot}
                          onChange={this.handelChangeVal}
                          placeholder='Enter Booking Slot (in Minutes)'
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Price Per Slot</label>
                          <SwInput
                          type="number"
                          name="price"
                          maxLength="8"
                          value={this.state.price}
                          onChange={this.handelChangeVal}
                          placeholder='Enter Price per slot'
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>24 X 7 Booking Allowance</label>
                          <label
                            class={
                              (this.state.setcolor = true
                                ? 'switch color'
                                : 'switch')
                            }
                            onClick={this.setColor}
                          >
                          </label>
                           <SwSwitchButtons
  id="booking24"
  name="booking24"    
  checked={this.state.booking24}
  onChange={this.togglecheked}
  size="lg"
  className="mt-1"
/>

                          <br />
                          <span className="smText">
                            Facilitate 24 x 7 availability of meeting rooms.
                          </span>

                        </div>
                      </div>
                    </div>
                    <div
                      className={this.state.hidVal == 1 ? 'row disp' : 'row '}
                    >
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Booking Start Time</label>
<AntDTimePicker
  name="starttime"
  value={this.state.starttime} 
  format="h:mm A"
  use12Hours
  minuteStep={1}
  placeholder="--:--"
  allowClear={false}
  onChange={(time) => {
    this.setState({ starttime: time });
  }}
/>
                        </div>
                      </div>
                    </div>
                    <div
                      className={this.state.hidVal == 1 ? 'row disp' : 'row '}
                    >
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Booking End Time</label>
                          <AntDTimePicker
                            name="endtime"
                            value={this.state.endtime} 
                            format="h:mm A"
                            use12Hours
                            minuteStep={1}
                            placeholder="--:--"
                            allowClear={false}
                            onChange={(time) => {
                              this.setState({ endtime: time });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </form>
       </SwOffCanvas>

        <SwIconButton size='sm'  onClick={this.openFilter}>
          <i className="bi bi-funnel" />
        </SwIconButton>

      </>
    );
  }
}

const mapStateToProps = state => ({
  roomTraingReducer: state.roomTraingReducer,
  CityNameReducer: state.roomTraingReducer.TrainingRoomCityData,
  BuildingReducer: state.roomTraingReducer.TrainingRoomBuilding,
  TowerReducer: state.roomTraingReducer.TrainingRoomTower,
  FloorReducer: state.roomTraingReducer.TrainingRoomFloor,
});

const mapActionsToProps = {
  RoomMaList,
  CityFilterAction,
  buildingFilterAction,
  TowerFilterAction,
  FloorFilterAction,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(RoomFilter);
